import { createFileRoute } from "@tanstack/react-router";
import EditorialStandards from "@/pages/EditorialStandards";

export const Route = createFileRoute("/_app/editorial-standards")({
  component: () => <EditorialStandards />,
});
